// shared
export const PERSONAL_INFO_STEP_INDEX = 0;

// tutor
export const TUTOR_STEPS = [
  {
    name: "page.accountInfo.accountInfo",
    route: "/tutor/fill-account-info",
  },
  { name: "page.sanadInfo.sanad", route: "/tutor/sanad-info" },
  { name: "page.freeTime.freeTime", route: "/tutor/free-time" },
];
export const SANAD_INFO_STEP_INDEX = 1;
export const FREE_TIME_STEP_INDEX = 2;

// student
export const STUDENT_STEPS = [
  {
    name: "page.accountInfo.accountInfo",
    route: "/student/fill-account-info",
  },
  {
    name: "page.student.tutorInfo.proposedSchedule",
    route: "/student/proposed-schedule",
  },
];
export const TUTOR_INFO_STEP_INDEX = 1;

// liaison
export const LIAISON_STEPS = [
  {
    name: "page.accountInfo.accountInfo",
    route: "/liaison/fill-account-info",
  },
];
// supervisor
export const SUPERVISOR_STEPS = [
  {
    name: "page.accountInfo.accountInfo",
    route: "/supervisor/fill-account-info",
  },
];
